import { recordThreadRead } from '#pplx/frontend/apps/ask/all-results/hooks/allResultsQuery.js';
import { getCollectionThreadsQueryKey, getSidebarProjectThreadsQueryKeyPrefix, } from '#pplx/frontend/apps/ask/queries/query-keys/collectionKeys.js';
import { getSpacePinnedThreadsQueryKey, getSpaceScheduledThreadsQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { RECENT_ITEMS_KEY, getSidebarV2InitialQueryKey, getAffectedSidebarProjectThreadQueries, getSidebarV2ProjectThreadsQueryKey, getPinnedItemsQueryKey, getPinnedThreadsQueryKey, getScheduledComputerTasksQueryKey, getThreadsQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/threadKeys.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
/** Patch GraphQL sidebar rows and refresh the other title consumers. */
export function updateThreadTitleCaches(queryClient, contextUUID, title, email) {
    const updateThread = (thread) => (thread.context_uuid === contextUUID ? { ...thread, title } : thread);
    queryClient.setQueriesData(getAffectedSidebarProjectThreadQueries({ contextUUIDs: [contextUUID] }), (old) => old && { ...old, items: old.items.map(updateThread) });
    queryClient.setQueriesData({
        queryKey: getSidebarV2InitialQueryKey(),
        predicate: ({ state }) => {
            const data = state.data;
            return (data?.pages.some((page) => page.pins?.items.some((item) => item.sidebarItemType !== 'automation' && item.context_uuid === contextUUID) ||
                page.projects?.some((project) => project.threads?.items.some((item) => item.context_uuid === contextUUID))) ?? false);
        },
    }, (old) => old && {
        ...old,
        pages: old.pages.map((page) => ({
            ...page,
            pins: page.pins && {
                ...page.pins,
                items: page.pins.items.map((item) => item.sidebarItemType === 'automation' ? item : updateThread(item)),
            },
            projects: page.projects?.map((project) => ({
                ...project,
                threads: project.threads && {
                    ...project.threads,
                    items: project.threads.items.map(updateThread),
                },
            })) ?? page.projects,
        })),
    });
    const queryKeys = [
        getCollectionThreadsQueryKey(),
        getSidebarProjectThreadsQueryKeyPrefix(),
        QueryClientHelper.makeQueryKey(RECENT_ITEMS_KEY, email),
        getThreadsQueryKey(),
        getPinnedThreadsQueryKey(),
        getPinnedItemsQueryKey(),
        getScheduledComputerTasksQueryKey(),
        getSpacePinnedThreadsQueryKey(),
        getSpaceScheduledThreadsQueryKey(),
        QueryClientHelper.makeQueryKey('all_results'),
        QueryClientHelper.makeQueryKey('thread_metadata'),
    ];
    queryKeys.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));
}
/**
 * Optimistically set `unread: false` in the React Query thread-list cache so
 * that a hard refresh or recent-items refetch does not briefly show a stale
 * unread badge before the SSE stream reconnects.
 */
export function setThreadsUnreadInCache(queryClient, contextUUIDs, unread) {
    if (!unread)
        contextUUIDs.forEach(recordThreadRead);
    const contextUUIDSet = new Set(contextUUIDs);
    const updateThreadResult = (thread) => contextUUIDSet.has(thread.context_uuid) ? { ...thread, unread } : thread;
    const updateRecentThread = (item) => item.context_uuid && contextUUIDSet.has(item.context_uuid) ? { ...item, unread } : item;
    queryClient.setQueriesData({ queryKey: getSidebarV2ProjectThreadsQueryKey() }, (old) => (old ? { ...old, items: old.items.map(updateThreadResult) } : old));
    for (const queryKey of [getThreadsQueryKey(), getCollectionThreadsQueryKey()]) {
        queryClient.setQueriesData({ queryKey }, (old) => {
            if (!old)
                return old;
            return {
                ...old,
                pages: old.pages.map((page) => page.map(updateThreadResult)),
            };
        });
    }
    for (const queryKey of [
        getPinnedThreadsQueryKey(),
        getScheduledComputerTasksQueryKey(),
        getSpacePinnedThreadsQueryKey(),
        getSidebarProjectThreadsQueryKeyPrefix(),
    ]) {
        queryClient.setQueriesData({ queryKey }, (old) => old?.map(updateThreadResult));
    }
    queryClient.setQueriesData({ queryKey: QueryClientHelper.makeQueryKey(RECENT_ITEMS_KEY) }, (old) => old?.map(updateRecentThread));
}
//# sourceMappingURL=threadCacheHelpers.js.map